<template>
  <v-container>
    <h6>Station {{name}}</h6>
    <v-form box>
      <v-text-field label='Site ID' disabled v-model='station.siteid' box></v-text-field>
      <v-text-field label='Site Description' multi-line v-model='station.shortsitedescription' box></v-text-field>
      <v-layout>
        <v-flex class="ma-2" xs6>
          <v-text-field label='Latitude' v-model='station.latitude' box></v-text-field>
        </v-flex>
        <v-flex class="ma-2" xs6>
          <v-text-field label='Longitude' v-model='station.longitude' box></v-text-field>
        </v-flex>
      </v-layout>
      <v-select label='Type' :items='types'></v-select>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    props: ['name'],
    data() {
      return {
        types: ['Surface Water', 'Ground Water', 'Hydrology'],
        programs: ['123'],
        station: {
          siteid: 'TODO',
          shortsitedescription: 'TODO',
          latitude: 'TODO',
          longitude: 'TODO',
          type: 'Surface Water',
        },
      }
    },
  }
</script>